import { Close16 } from 'ui/icons/action/Close16';
import { noop } from 'utils/noop';
import { TagContainer } from './Tag.styled';

// type Props = {
//   /* Additional class names. */
//   className: ?string,
//   /* Callback when delete button is clicked. */
//   onDelete: ?(*) => void,
//   /* Text to display for the tag. */
//   text: string,
//   /* The value of the tag. */
//   value: ?string,
// };

const Tag = ({ className, text, onDelete = noop, value }) => {
  const handleDelete = () => {
    onDelete({ text, value });
  };

  return (
    <TagContainer className={className} title={text}>
      <div>{text || value}</div>
      {onDelete && <Close16 data-test="tag-delete-icon" onClick={handleDelete} />}
    </TagContainer>
  );
};

export default Tag;
